export const GIA = 'GIA';
export const NOT_CORRECT_EXAM_FROM = 'NOT_CORRECT_EXAM_FROM';
